import { render, staticRenderFns } from "./MaterialReservationTable.vue?vue&type=template&id=29bf5110&scoped=true"
import script from "./MaterialReservationTable.vue?vue&type=script&lang=js"
export * from "./MaterialReservationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bf5110",
  null
  
)

export default component.exports